import React, { Component } from 'react';
import { withCookies } from 'react-cookie';
import isEmpty from 'lodash/isEmpty';
import withStyles from '../../../core/isomorphic-style-loader/withStyles';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module './BookingWidgetConfirm.css' or... Remove this comment to see the full error message
import s from './BookingWidgetConfirm.css';
import Layout from '../../../components/Layout';
import MobileBookingWidgetSecondForm from '../../../components/BookingWidget/Mobile/MobileBookingWidgetSecondForm';
import history from '../../../core/history';
import AppointmentRecapCard from '../../../components/BookingWidget/components/AppointmentRecapCard';
import { isInMarketPlace } from '../../../core/util/location';
import { createLocationUrlFromLocation } from '../../../core/url/location';
import { clearUserInfo } from '../../../core/session';
import { LOGIN_SIGN_UP_MODAL } from '../../../components/LoginSignUpModal';
import withAuthentication from '../../../core/login/withAuthentication';
import { EN, SupportedLocale } from '../../../core/util/localizedStr';

type Props = {
  locationId?: string;
  fetchLocation?: (...args: any[]) => any;
  setLocation?: (...args: any[]) => any;
  locale?: SupportedLocale;
  location?: any;
  accountSummary?: any;
  newBooking?: any;
  login?: any;
  requestId?: string;
  pastBookings?: any;
  setUserProfile?: (...args: any[]) => any;
  userProfile?: any;
  insurers?: any[];
  fetchInsuranceData?: (...args: any[]) => any;
  handleFormSubmission?: (...args: any[]) => any;
  showModal?: (modalId: string) => void;
  hideModal?: (modalId: string) => void;
  resetData?: (...args: any[]) => any;
  handleMobileSecondFormSubmit?: (...args: any[]) => any;
  resetLogin?: (...args: any[]) => any;
  searchPreferences?: any;
  setFlowStep?: (...args: any[]) => any;
  flowStep?: string;
  isLoggedIn: boolean;
  cookies: any;
  setBookingProfilePending?: (arg: boolean) => void;
};

class BookingWidgetConfirm extends Component<Props> {
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    if (isEmpty(this.props.newBooking.booking)) {
      if (!isEmpty(this.props.pastBookings)) {
        const { pastBookings } = this.props;
        let locationId = '';
        let appointmentTime = 0;
        for (const booking in pastBookings) {
          if (pastBookings.hasOwnProperty(booking)) {
            if (pastBookings[booking].appointmentTime > appointmentTime) {
              locationId = pastBookings[booking].locationId;
              appointmentTime = pastBookings[booking].appointmentTime;
            }
          }
        }

        history.replace(`/book-online/${locationId}`);
      }
    }
  }

  renderContent() {
    const handleLogin = (e: any) => {
      e.preventDefault();

      this.props.showModal?.(LOGIN_SIGN_UP_MODAL);
    };

    return (
      <div className={s.container}>
        <AppointmentRecapCard
          booking={this.props.newBooking.booking}
          locale={this.props.locale ?? EN}
          location={this.props.location}
        />

        <div className={s.appointmentInfo}>
          <MobileBookingWidgetSecondForm
            accountSummary={this.props.accountSummary}
            allowLocationChange={false}
            handleFormSubmit={this.props.handleMobileSecondFormSubmit}
            handleLogin={handleLogin}
            locale={this.props.locale}
            location={this.props.location}
            login={this.props.login}
            newBooking={this.props.newBooking}
            setBookingProfilePending={this.props.setBookingProfilePending}
            setUserProfile={this.props.setUserProfile}
            showModal={this.props.showModal}
          />
        </div>
      </div>
    );
  }

  render() {
    const handleLogoOnClick = () => {
      if (isInMarketPlace(this.props.location)) {
        clearUserInfo(this.props.cookies);

        this.props.resetData?.();
        history.push(createLocationUrlFromLocation(this.props.location));
      } else {
        history.push(`/book-online/${this.props.location.id}`);
      }
    };

    const handleResetLogin = () => this.props.resetLogin?.(this.props.location);

    return (
      <div className={s.root}>
        {!isEmpty(this.props.location) && (
          <Layout
            handleLogoOnClick={handleLogoOnClick}
            hasDesktopStyling
            header="v1"
            hideFooter
            logoutLink
            resetLogin={handleResetLogin}
            showBackArrow={false}
            showSiteMenu={false}
          >
            {this.renderContent()}
          </Layout>
        )}
      </div>
    );
  }
}

export default withStyles(s)(withCookies(withAuthentication(BookingWidgetConfirm)));
